import { useNavigate } from "react-router-dom"
import { Stack, Typography } from "@mui/material"
import { makeStyles } from "tss-react/mui"

import { MERCHANT_MENU_PLANNING_TEMPLATE_CREATE_ROUTE } from "../../../../../../constants/routes"
import { LocalizedStrict } from "../../../../../localization/components/AppLocalized"
import { StandardButton } from "../../../../../../shared/components/buttons/StandardButton"

const useStyles = makeStyles()((theme) => ({
    emptyState: {
        padding: "3rem 1rem",
        textAlign: "center",
    },
    message: {
        color: theme.palette.tailwind.gray[500],
        maxWidth: "26rem",
    },
}))

/** Shown when the kitchen has no menu templates yet: the week menu needs one to start from. */
export function WeekMenuEmptyState() {
    const { classes } = useStyles()
    const navigate = useNavigate()

    return (
        <Stack spacing="1rem" alignItems="center" className={classes.emptyState}>
            <LocalizedStrict id="merchant-week-menu-no-templates-title">
                <Typography variant="h6">No menu templates yet</Typography>
            </LocalizedStrict>
            <LocalizedStrict id="merchant-week-menu-no-templates-message">
                <Typography variant="body2" className={classes.message}>
                    To plan a week menu, first create a template with your categories and dishes.
                </Typography>
            </LocalizedStrict>
            <LocalizedStrict id="merchant-week-menu-create-template-button">
                <StandardButton
                    fullWidth={false}
                    onClick={() => navigate(MERCHANT_MENU_PLANNING_TEMPLATE_CREATE_ROUTE)}
                >
                    Create template
                </StandardButton>
            </LocalizedStrict>
        </Stack>
    )
}
